/* This component is used for the wishlist/favourite heart icon in the pdp, header etc. */
import Favourite from "@/components/Logos/favourite";
import Srcset from "../Srcset";

/* Props:
  isFilled: boolean - Optional (Signifies if the heart icon should be filled or not) 
  className: String - Optional (If a custom class is to be added)
  animationEndHandler - Optional (Action to be taken on end of animation)
  */
export default function FavouriteIcon({
  isFilled = false,
  className = "",
  animationEndHandler = () => {},
  width,
  height,
  isSuper,
  isAddtoBagWrapper = false,
  isPWA,
}) {
  return isPWA ? (
    <Srcset
      requirePath={true}
      svgFile={true}
      src={
        isFilled ? "images/Icons/Favourited.svg" : "images/Icons/Favourites.svg"
      }
      alt="Wishlist"
      height={height}
      width={width}
      className={className}
      dataga4={"App: Wishlist"}
    />
  ) : (
    <Favourite
      onAnimationEnd={animationEndHandler}
      className={
        isAddtoBagWrapper ? `${className} fav-add-to-bag-ga` : `${className}`
      }
      width={width}
      height={height}
      stroke={isSuper ? "#ffffff" : "#2f2f30"}
      fill={isFilled ? (isSuper ? "#ffffff" : "#2f2f30") : "none"}
    />
  );
}
